import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface ModuleCredentialsResponse {
	apiKey: string;
	hasSecret: boolean;
	secretCreatedAt: number | null;
}

export interface RotateSecretResponse {
	apiKey: string;
	apiSecret: string;
	secretCreatedAt: number;
}

export interface RevokeSecretResponse {
	apiKey: string;
	hasSecret: boolean;
	secretCreatedAt: number | null;
}

@Injectable({ providedIn: 'root' })
export class WorldModuleCredentialsService {
	constructor(private readonly http: HttpClient) {}

	get(worldId: string): Observable<ModuleCredentialsResponse> {
		return this.http.get<ModuleCredentialsResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/module-credentials`);
	}

	rotateSecret(worldId: string): Observable<RotateSecretResponse> {
		return this.http.post<RotateSecretResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/module-credentials/rotate-secret`, {});
	}

	revokeSecret(worldId: string): Observable<RevokeSecretResponse> {
		return this.http.post<RevokeSecretResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/module-credentials/revoke-secret`, {});
	}
}
